<div class="title">{{'crossTherapy.document.summary.article' | translate}}</div>
<div *ngFor="let articleLine of articleLines">
  <cross-therapy-summary-list-item [articleLine]="articleLine"> </cross-therapy-summary-list-item>
</div>
